import React, { useState } from "react";
import styled from "styled-components";
import {
  Wrapper,
  Title,
  Body,
  Column,
  ColumnTitle,
  ColumnValue,
} from "./styles/box-styles";
import CvModal from "../shared/general/CvModal";
import Button from "../shared/button/Button";
import Candidate from "../../apiResources/Candidate";
import { useModal } from "../../hooks";

export const WorkInformation = (props: Props) => {
  const { candidate } = props;
  const cvModal = useModal(false);

  const { symbol } = candidate.recruiter.currency;

  return (
    <>
      <Wrapper className="animated delay-2 fadeIn" workInformation>
        <Title>Work Information</Title>
        <Body>
          <Column>
            <ColumnTitle>Current Salary</ColumnTitle>
            <ColumnValue>
              {`${symbol}${candidate.currentSalary}` || "no data"}
            </ColumnValue>
          </Column>
          <Column>
            <ColumnTitle>Desired Salary</ColumnTitle>
            <ColumnValue>
              {`${symbol}${candidate.desiredSalary}` || "no data"}
            </ColumnValue>
          </Column>
          <Column>
            <ColumnTitle>Current Employer</ColumnTitle>
            <ColumnValue>{candidate.currentEmployer || "no data"}</ColumnValue>
          </Column>
          {/* <Column>
            <ColumnTitle>Job Type</ColumnTitle>
            <ColumnValue capitalize>{candidate.jobType}</ColumnValue>
          </Column> */}
          <Column>
            <ColumnTitle>Notice Period</ColumnTitle>
             <ColumnValue>
              {candidate.noticePeriod || "-"}
            </ColumnValue>
          </Column>
          <Column noAlign cvField>
            <Button buttonName="View CV" primary onClickAction={cvModal.open} />
          </Column>
        </Body>
      </Wrapper>
      {cvModal.isOpen && (
        <CvModal
          toggleModal={cvModal.close}
          cvDownloadPath={`/candidates/${candidate.id}/cv_download`}
          pdfUrl={`/candidates/${candidate.id}/cv_data`}
        />
      )}
    </>
  );
};

type Props = {
  candidate: Candidate;
};

export default WorkInformation;
